import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './RemoteOralExam.scss';
import remoteOralExamService from '../../services/RemoteOralExamService';
import Topic from './Topic';

const RemoteOralExam = ({ sessionInfo, showTopic }) => {
    const outerClass = showTopic ? styles.splitScreen : '';

    return (<div className={styles.topicContainer}>
        <div className={outerClass}>
            { showTopic && <Topic questionId={sessionInfo.contextObjectId} /> }
            <div className={styles.zoomCallPlaceholder} />
        </div>
    </div>);
};

RemoteOralExam.propTypes = {
    sessionInfo: PropTypes.object.isRequired,
    showTopic: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const { remoteOralExam: { sessionInfo } } = state;

    return {
        sessionInfo,
        showTopic: remoteOralExamService.isDisplayStatusVisible(sessionInfo),
    };
};

export default connect(mapStateToProps)(RemoteOralExam);
